// src/services/geo.js
// Fetches country code once via IP geolocation, caches in localStorage.
// Converts country code to Unicode flag emoji.

const STORAGE_KEY = 'pzm_country';

export async function getCountryCode() {
  const cached = localStorage.getItem(STORAGE_KEY);
  if (cached) return cached;
  try {
    const r = await fetch('https://ipapi.co/json/');
    const d = await r.json();
    const code = (d.country_code || 'XX').toUpperCase().slice(0, 2);
    localStorage.setItem(STORAGE_KEY, code);
    return code;
  } catch {
    return 'XX';
  }
}

export function toFlag(code) {
  if (!code || code.length !== 2) return '🌐';
  return [...code.toUpperCase()]
    .map(c => String.fromCodePoint(c.charCodeAt(0) + 127397))
    .join('');
}
